/**
 * ScrollToTop Component
 *
 * Automatically scrolls to top of page on route change.
 * Essential for good UX when navigating between pages.
 *
 * Best Practice: Place inside Router but outside Routes
 */

import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    // Scroll to top whenever pathname changes
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'instant' // Use 'instant' for immediate scroll, 'smooth' for animated
    });
  }, [pathname]);

  return null; // This component doesn't render anything
}

export default ScrollToTop;
